import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  AppBar
} from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

const TabsNavBar = ({ className, value, ...rest }) => {
  function LinkTab(props) {
    return <Tab component={RouterLink} {...props} />;
  }

  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      "aria-controls": `scrollable-auto-tabpanel-${index}`,
    };
  }

  return (
      <AppBar position="static" color="default">
            <Tabs
              value={value}
              indicatorColor="primary"
              variant="scrollable"
              scrollButtons="on"
              aria-label="scrollable auto tabs example"
            >
              
              <LinkTab
                label="W przygotowaniu"
                to="/zarzadzanieglosowania/wprzygotowaniu"
                {...a11yProps(0)}
              />
              <LinkTab
                label="W trakcie"
                to="/zarzadzanieglosowania/wtrakcie"
                {...a11yProps(1)}
              />
              <LinkTab
                label="Zakończone"
                to="/zarzadzanieglosowania/zakonczone"
                {...a11yProps(2)}
              />
              <LinkTab
                label="Anulowane"
                to="/zarzadzanieglosowania/anulowane"
                {...a11yProps(3)}
              />
            </Tabs>
          </AppBar>
  );
};

export default TabsNavBar;
